import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_ALL_TIER_FEATURE_REQUEST =
  'tierFeature/FETCH_ALL_TIER_FEATURE_REQUEST'
const FETCH_ALL_TIER_FEATURE_SUCCESS =
  'tierFeature/FETCH_ALL_TIER_FEATURE_SUCCESS'
const FETCH_ALL_TIER_FEATURE_FAILURE =
  'tierFeature/FETCH_ALL_TIER_FEATURE_FAILURE'

const CREATE_TIER_FEATURE_REQUEST = 'tierFeature/CREATE_TIER_FEATURE_REQUEST'
const CREATE_TIER_FEATURE_SUCCESS = 'tierFeature/CREATE_TIER_FEATURE_SUCCESS'
const CREATE_TIER_FEATURE_FAILURE = 'tierFeature/CREATE_TIER_FEATURE_FAILURE'

const UPDATE_TIER_FEATURE_REQUEST = 'tierFeature/UPDATE_TIER_FEATURE_REQUEST'
const UPDATE_TIER_FEATURE_SUCCESS = 'tierFeature/UPDATE_TIER_FEATURE_SUCCESS'
const UPDATE_TIER_FEATURE_FAILURE = 'tierFeature/UPDATE_TIER_FEATURE_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  tierFeatureList: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_TIER_FEATURE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_ALL_TIER_FEATURE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tierFeatureList: action.payload
      }
    case FETCH_ALL_TIER_FEATURE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_TIER_FEATURE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_TIER_FEATURE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_TIER_FEATURE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_TIER_FEATURE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_TIER_FEATURE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_TIER_FEATURE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export const getAllTierFeatureList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_ALL_TIER_FEATURE_REQUEST
      })

      const response = await API.get(EndPoints.TIER_FEATURE)

      dispatch({
        type: FETCH_ALL_TIER_FEATURE_SUCCESS,
        payload: response.data
      })
    } catch (error) {
      const backendMessage =
        error.response && error.response.data && error.response.data.message
      message.error(backendMessage || RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: FETCH_ALL_TIER_FEATURE_FAILURE
      })
    }
  }
}

export const getTierFeature = (tier) => {
  return async () => {
    try {
      const response = await API.get(`${EndPoints.TIER_FEATURE}/${tier}`)
      return response.data
    } catch (error) {
      const backendMessage =
        error.response && error.response.data && error.response.data.message
      if (!error.response || error.response.status !== 404) {
        message.error(backendMessage || RESPONSE_MESSAGE.FAIL)
      }
      return null
    }
  }
}

export const createTierFeature = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_TIER_FEATURE_REQUEST
      })

      await API.post(EndPoints.TIER_FEATURE, data)

      dispatch({
        type: CREATE_TIER_FEATURE_SUCCESS
      })
      return true
    } catch (error) {
      const backendMessage =
        error.response && error.response.data && error.response.data.message
      message.error(backendMessage || RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_TIER_FEATURE_FAILURE
      })
      return false
    }
  }
}

export const updateTierFeature = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_TIER_FEATURE_REQUEST
      })

      await API.put(EndPoints.TIER_FEATURE, data)

      dispatch({
        type: UPDATE_TIER_FEATURE_SUCCESS
      })
      return true
    } catch (error) {
      const backendMessage =
        error.response && error.response.data && error.response.data.message
      message.error(backendMessage || RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_TIER_FEATURE_FAILURE
      })
      return false
    }
  }
}
